var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './EmailPage.module.css';
import { useCallback, useMemo, useState, } from 'react';
import { PageLayout } from '../../Components/PageLayout';
import { Input } from '../../Components/BaseComponents/Input';
import { Checkbox } from '../../Components/BaseComponents/Checkbox';
import { GoogleAuth } from '../../GoogleBtn';
import { useApplication } from '../../Contexts/ApplicationContext';
import { observer } from 'mobx-react-lite';
import { useSettings } from '../../Contexts/SettingsContext';
import { useAnalytics } from '../../Contexts/AnalyticsContext';
import { TermsOfServiceCheckbox } from '../../Components/TermsOfServiceCheckbox';
export var EmailPage = observer(function () {
    var _a, _b;
    var _c = useApplication(), orderFacade = _c.orderFacade, stepController = _c.stepController;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var defaultValues = useSettings().defaultValues;
    var _e = useAnalytics(), track = _e.track, identify = _e.identify;
    var emailFromSettings = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.email;
    var emailFromStep = 'email' in stepController.currentStep
        ? stepController.currentStep.email
        : undefined;
    var subscribeFromStep = 'subscribe' in stepController.currentStep
        ? stepController.currentStep.subscribe
        : undefined;
    var _f = useState(false), agreeRules = _f[0], setAgreeRules = _f[1];
    var _g = useState(subscribeFromStep || orderFacade.userInfo.subscribe || false), subscribe = _g[0], setSubscribe = _g[1];
    var _h = useState({}), error = _h[0], setError = _h[1];
    var _j = useState(((_a = orderFacade.userInfo) === null || _a === void 0 ? void 0 : _a.email) ||
        (emailFromSettings === null || emailFromSettings === void 0 ? void 0 : emailFromSettings.value) ||
        emailFromStep ||
        ''), email = _j[0], setEmail = _j[1];
    var isEmailVerificatedEarly = useMemo(function () {
        var _a;
        return emailFromStep || ((_a = orderFacade.userInfo) === null || _a === void 0 ? void 0 : _a.email);
    }, [emailFromStep, (_b = orderFacade.userInfo) === null || _b === void 0 ? void 0 : _b.email]);
    var validate = useCallback(function () {
        if (email &&
            email.indexOf('@') >= 0 &&
            (agreeRules || isEmailVerificatedEarly)) {
            return true;
        }
        if (!email) {
            var errorText_1 = 'Email is required';
            setError(function (prevState) { return (__assign(__assign({}, prevState), { email: errorText_1 })); });
            track('error_raised', { error: errorText_1 });
        }
        else if (email.indexOf('@') < 0) {
            var errorText_2 = 'Email format is invalid';
            setError(function (prevState) { return (__assign(__assign({}, prevState), { email: errorText_2 })); });
            track('error_raised', { error: errorText_2 });
        }
        if (!agreeRules && !isEmailVerificatedEarly) {
            var errorText_3 = 'You should agree with rules';
            setError(function (prevState) { return (__assign(__assign({}, prevState), { rules: errorText_3 })); });
            track('error_raised', { error: errorText_3 });
        }
        return false;
    }, [agreeRules, email, isEmailVerificatedEarly, track]);
    var handleSubmit = useCallback(function () {
        if (validate()) {
            setLoading(true);
            orderFacade
                .sendEmail({ email: email, subscribe: subscribe })
                .then(function () {
                identify({ email: email });
                track('email_submitted', { is_google: false });
            })
                .catch(function (err) {
                var _a, _b;
                var errorText = ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || 'Something went wrong';
                setError(function (prevState) { return (__assign(__assign({}, prevState), { email: errorText })); });
            })
                .finally(function () {
                setLoading(false);
            });
        }
    }, [email, identify, orderFacade, subscribe, track, validate]);
    var handleChange = useCallback(function (e) {
        setError(function (prevState) { return (__assign(__assign({}, prevState), { email: undefined })); });
        setEmail(e.target.value);
    }, []);
    var handleChangeAgreeRules = useCallback(function () {
        if (error.rules) {
            setError(function (prevState) { return (__assign(__assign({}, prevState), { rules: undefined })); });
        }
        setAgreeRules(function (e) { return !e; });
    }, [error.rules]);
    var sendGmailToken = function (gToken) {
        setLoading(true);
        orderFacade
            .sendEmail({ gToken: gToken, subscribe: subscribe })
            .then(function () {
            identify({});
            track('email_submitted', { is_google: true });
            track('email_code_submitted');
        })
            .catch(function (err) {
            setError(function (prevState) { return (__assign(__assign({}, prevState), { email: err.response.data.message })); });
        })
            .finally(function () {
            setLoading(false);
        });
    };
    var handleSubmitGBtn = function (gToken) {
        if (isEmailVerificatedEarly || agreeRules) {
            sendGmailToken(gToken);
        }
        else {
            var error_1 = agreeRules
                ? { email: 'Something went wrong' }
                : { rules: 'You should agree with rules' };
            setError(function (prevState) { return (__assign(__assign({}, prevState), error_1)); });
        }
    };
    return (_jsxs(PageLayout, __assign({ footer: {
            actionButtonLabel: 'Next',
            buttonClick: handleSubmit,
            actionButtonLoader: loading,
        } }, { children: [_jsx("h2", __assign({ className: styles.title }, { children: "Enter your email" })), _jsx("p", __assign({ className: styles.text }, { children: "We will send the details and confirmation of the transaction to it" })), _jsx(Input, { autoFocus: true, disabled: Boolean((emailFromSettings === null || emailFromSettings === void 0 ? void 0 : emailFromSettings.value) && !(emailFromSettings === null || emailFromSettings === void 0 ? void 0 : emailFromSettings.editable)), value: email, dataTestId: "email-input", label: "My email", placeholder: "myaddress@mailbox.czce", onChange: handleChange, error: Boolean(error.email), helpText: error.email }), _jsx("div", __assign({ style: { display: 'flex', justifyContent: 'center' } }, { children: _jsx(GoogleAuth, { handleSuccess: handleSubmitGBtn }) })), _jsx(TermsOfServiceCheckbox, { hide: Boolean(isEmailVerificatedEarly), error: Boolean(error.rules), onClick: handleChangeAgreeRules, checked: agreeRules }), (orderFacade.userInfo.subscribe && isEmailVerificatedEarly) ||
                subscribeFromStep ? null : (_jsx(Checkbox, __assign({ dataTestId: "subscribe-checkbox", style: { marginTop: 16 }, checked: subscribe, onChange: function () { return setSubscribe(function (e) { return !e; }); } }, { children: "Receive updates news" })))] })));
});
